import React, { useState, Fragment, useEffect } from 'react';
import { useStyle } from '../../components/eir-payment/style';
import {
    Paper, Grid,
    Box, Button,
    Stepper, Step, StepLabel
} from '@material-ui/core';
import { makeStyles, withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';


export default function EirCustomiseOrderSummaryStepper() {
    const classes = useStyle();
    const defaultTheme = createMuiTheme();
    const eir_be_data = JSON.parse(localStorage.getItem("eir_be_data"));

  //  setStandAlone((eir_be_data.bundleDetails === undefined) ? true : false);
  
    // const [mobileBroadband, setMobileBroadband] = useState(false);
    // const [standaloneMobile, setStandaloneMobile] = useState(false);
    // setMobileBroadband((eir_be_data.order.bundle.hasMobileBroadbandPostpay || eir_be_data.order.bundle.hasMobileBroadbandPrepay));
    // setStandaloneMobile(eir_be_data.order.bundle.standaloneMobile);         
    const goBack = () => {
        if(eir_be_data.bundleDetails != undefined){
            window.location.href = "/customise-bundles/"        
        }
        else if(eir_be_data.order.bundle.hasMobileBroadbandPostpay || eir_be_data.order.bundle.hasMobileBroadbandPrepay){
            window.location.href = "/mobile/broadband/";
        }
        else if(eir_be_data.order.bundle.standaloneMobile){
           // window.location.href = "/mobile/bill-pay/";
           window.history.back();
        }
        else{
            window.history.back();
        }
    }

    return (

        <Grid>
            <Paper elevation={3} className={"checkout_container"}>
                <div className={" order_checkout_container"}>
                    <a onClick={goBack} className={" float-left checkoutStep_back "}>
                        Back
                    </a>
                    <Grid item xs={12} id="customer_checkout_container">
                        <Box display={{ xs: 'block', md: 'block' }} >
                            <Stepper class={"orderStepperContainer"} >
                                <div class={"checkoutSummary"}>
                                    Checkout
                                </div>
                            </Stepper>
                        </Box>

                    </Grid >
                    {/* <a href="/checkout/customer-details/" class={" float-right checkoutStep_next "}>
                        Next
                    </a> */}
                </div >
            </Paper>
        </Grid>


    );
}